<template>
  <button
    :class="[
      'flex items-center justify-center',
      'bg-primary-green text-white font-heading font-normal py-4 px-10 rounded-[40px] hover:bg-primary-green-dark transition-colors duration-200',
    ]"
    :type="type"
    :aria-label="ariaLabel"
  >
    <slot></slot>
  </button>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  type: {
    type: String,
    default: "button",
    validator: (value) => ["button", "submit", "reset"].includes(value),
  },
  ariaLabel: {
    type: String,
    default: undefined,
  },
});
</script>

<script>
export default {
  name: "ButtonMain",
};
</script>
